import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_138: FaireProductEntity = {
  token: "legacy_prod_abbott-138",
  type: "product",
  name: "Butterfly Garden Canister-5.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/cbb8fb5182254f3dbec8ec44a06e82ea128b42259ec9a3b9578fb71e8d01f989.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
